import toastMessage from './Toast';

export default toastMessage;
